import { DataTypes } from "../../../data/DataManager";
import { FieldSchema, FieldValues } from "../../../Schema";

/**
 * Cluster master data picker. Unlike the equipment picker it composes no
 * manufacturer — a cluster is identified by category / model / variant only —
 * so the picker draws from the cluster category mappings (see the frontend's
 * ClusterMasterDataPicker, rendered with `isCluster`).
 */
export const masterDataPicker: FieldSchema = {
  name: "masterDataPicker",
  graphql: { selection: undefined },
  dataTransform: {
    fromGraphql: {
      getter: ({ equipmentCategory, equipmentModel, variant }: FieldValues) => {
        if (equipmentCategory && equipmentModel) {
          return { equipmentCategory, equipmentModel, variant };
        }
        return null;
      },
      fields: ["equipmentCategory", "equipmentModel", "variant"],
    },
    toGraphql: undefined,
  },
  data: { type: DataTypes.OBJECT },
  validation: { required: true },
  form: {},
};
